import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MaterialTable from "material-table";
import {
  CustomTable,
  EditIconCustom,
  DeleteIconCustom,
  ActiveStatus,
  InActiveStatus,
  ARStatus,
} from "../style";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Typography from "@material-ui/core/Typography";

import {
  actionDeleteUserProfile,
  // actionSetGridActions
} from "../actions";

import "../index.css";
import {
  commonCellStyle,
  commonHeaderStyle,
  commonTableStyle,
  commonHeaderStyleDarker,
} from "./Styles";
import { getLocalDateFromUTC, getLoggedInCurrentUserDetails } from "src/utils";
import { accessTypeData } from "src/constants/dropdown";
import ConfirmDialog from "../../../components/common/confirm-dialog.component";

function UserProfileTableComponent(props: any) {
  const { functionEditForm, useProfileFilterData } = props;
  const dispatch = useDispatch();
  const [gridData, setGridData] = useState([]);
  const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);
  const [idToDelete, setIdToDelete] = useState("");

  let selectedRow: any = null;

  useEffect(() => {
    let gridData: any = [];
    if (useProfileFilterData && useProfileFilterData.length) {
      useProfileFilterData.map((item: any) => {
        const { name, firstName, lastName, emails } = getLoggedInCurrentUserDetails(item);
        gridData.push({
          ...item,
          firstName,
          lastName,
          emails,
        });
        setGridData(gridData);
      });
    }

  }, [useProfileFilterData])

  const handlerEditRowData = (event: any, rowData: any) => {
    functionEditForm(rowData);
  };

  //@ts-ignore
  const handlerDeleteRowData = (event: any, rowData: any) => {    
    setIdToDelete(rowData.id);
    setIsOpenConfirmDialog(true);
  };

  // const handlerSerialNumberRowData = (row: any) => {
  //   return row["tableData"].id + 1;
  // };

  const renderTableData = (userRoleMapping: any) => {
    if (userRoleMapping.length) {
      return userRoleMapping.map((item: any, index: any) => {
        const { roleName } = item;

        return (
          <Typography component="tr" key={index}>
            <Typography
              component="td"
              className="width18 noBorder"
            ></Typography>
            <Typography component="td" className="width8 noBorder">
              <Typography component="span">{roleName}</Typography>
            </Typography>
            {/* <Typography component="td" className="width9 noBorder">
              <Typography component="span">{region}</Typography>
            </Typography>
            <Typography component="td" className="width34 noBorder">
              <Typography component="span">{country}</Typography>
            </Typography> */}
          </Typography>
        );
      });
    }
  };
  const clickRow = (rowData: any) => {
    //setSelectedRow(rowData.tableData.id);
    selectedRow = rowData.tableData.id;
    return <ExpandLessIcon />;
  };

  const handleDisable = (rowData: any) => {
    if (
      Object.keys(rowData).length > 1 &&
      rowData.hasOwnProperty("userRoleMapping") &&
      rowData.userRoleMapping.length > 1
    ) {
      return <ExpandMoreIcon />;
    } else {
      return <></>;
    }
  };

  const handleUserStatusIcon = (rowData: any) => {
    if (
      Object.keys(rowData).length > 1
    ) {
      if (rowData.isActive) {
        return <ActiveStatus title="Active" />;
      } else {
        return <InActiveStatus title="Inactive" />;
      }
    } else {
      return <ARStatus title="Access Required" />;
    }
  };

  const closeConfirmDialog = (index: any) => {
    setIdToDelete("");
    setIsOpenConfirmDialog(false);
  };

  return (
    <>
      <ConfirmDialog
        open={isOpenConfirmDialog}
        close={closeConfirmDialog}
        title="Are you sure, you want to delete this user?"
        content=""
        ok={() => {
          dispatch(actionDeleteUserProfile(idToDelete));
          setIsOpenConfirmDialog(false);
          setIdToDelete("");
        }}
      />
      <MaterialTable
        title="Manage Users"
        columns={[
          {
            title: "Status",
            field: "isActive",
            filtering: true,
            cellStyle: {
              ...commonCellStyle, textAlign: "center",
              maxWidth: "80px",
            },
            render: (tblProps: any) => {
              return handleUserStatusIcon(tblProps);
            },
          },
          {
            title: "First Name",
            field: "firstName",
            filtering: true,
            cellStyle: {
              ...commonCellStyle,
              maxWidth: "150px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          },
          {
            title: "Last Name",
            field: "lastName",
            filtering: true,
            cellStyle: {
              ...commonCellStyle,
              maxWidth: "150px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          },
          {
            title: "Email",
            field: "emails",
            filtering: true,
            cellStyle: {
              ...commonCellStyle,
              maxWidth: "220px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
            render: (rowData: any) => (
              <span title={rowData.emails}>
                {rowData.emails}
              </span>
            ),
          },
          {
            title: "Role",
            field: "rolesName",
            filtering: true,
            cellStyle: {
              ...commonCellStyle,
              whiteSpace: "nowrap",
            },
            headerStyle: commonHeaderStyleDarker,
            render: (rowData: any) => {
              if (rowData.role) {
                return <span>{rowData.role.name}</span>;
              }
            },
          },
          {
            title: "Access For",
            field: "accessFor",
            filtering: true,
            cellStyle: {
              ...commonCellStyle,
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
            render: (tblProps: any) => {
              const filterAccessFor = accessTypeData.filter((w: any) => w.id === tblProps.accessFor);
              if (filterAccessFor && filterAccessFor.length) {
                return <span>{filterAccessFor[0].label}</span>;
              }
              else {
                return <span></span>;
              }

            },
          },
        ]}
        style={commonTableStyle}
        data={gridData}
        detailPanel={[
          (rowData: any) => ({
            icon: () => handleDisable(rowData),
            openIcon: () => clickRow(rowData),
            render: () => (
              <>
                <CustomTable className="detailsPannel">
                  <Typography component="tbody">
                    {renderTableData(rowData.userRoleMapping)}
                  </Typography>
                </CustomTable>
              </>
            ),
          }),
        ]}
        options={{
          filtering: true,
          toolbar: false,
          pageSizeOptions: [10, 20, 50],
          pageSize: 10,
          emptyRowsWhenPaging: false,
          // actionsColumnIndex: -1,
          detailPanelColumnAlignment: "left",
          detailPanelType: "single",
          // actionsCellStyle: commonCellStyle,
          headerStyle: commonHeaderStyle,
          rowStyle: (rowData) => ({
            backgroundColor:
              selectedRow === rowData.tableData.id ? "#f6fbfd" : "#FFF",
            borderBottomColor: "#fff",
          }),
        }}
        actions={[
          {
            icon: () => <EditIconCustom />,
            tooltip: "Edit",
            onClick: (event, rowData) => handlerEditRowData(event, rowData),
          },
          {
            icon: () => <DeleteIconCustom />,
            tooltip: "Delete",
            onClick: (event, rowData) => handlerDeleteRowData(event, rowData),
          },
        ]}
      />
    </>
  );
}

export default UserProfileTableComponent;
